module.exports = __webpack_public_path__ + "img/ff9d7e9.png";